export * from '@/assets/icons/thin/thin';
